import { Head } from 'vite-react-ssg';

const SITE_URL = 'https://driscop.co.uk';

interface PageMetaProps {
  /** Route path starting with "/", e.g. "/about". Use "/" for the homepage. */
  path: string;
}

/**
 * Overrides the canonical link and og:url for the current route.
 * index.html sets sensible site-wide defaults (pointing at "/"); every
 * non-home page must render this so it isn't left claiming the homepage
 * as its canonical URL.
 */
export function PageMeta({ path }: PageMetaProps) {
  const url = path === '/' ? `${SITE_URL}/` : `${SITE_URL}${path}`;

  return (
    <Head>
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
    </Head>
  );
}
